/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Integrations_Credentials_Connect_ButtonInputs */



/**
* | output |
* | --- |
* | "Connect credentials" |
*
* @param {Integrations_Credentials_Connect_ButtonInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const integrations_credentials_connect_button = /** @type {((inputs?: Integrations_Credentials_Connect_ButtonInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Integrations_Credentials_Connect_ButtonInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Zugangsdaten hinterlegen")
	return /** @type {LocalizedString} */ ("Connect credentials")
});